<bp-picture *ngFor="let imgSrc of companiesTilesImgsSrcs" [src]="imgSrc"></bp-picture>
